import React from "react";
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";

import Logo from "@components/Logo";

const Copyright: React.FC<{}> = () => {
  const copyrightDate = new Date().getFullYear();
  return (
    <>
      <CopyrightContainer>
        <Logo width="65" height="70" fill="#ffffff" />
        <CopyrightDateText>
          © {copyrightDate} Base
        </CopyrightDateText>
      </CopyrightContainer>
    </>
  );
};

const CopyrightContainer = styled.div`
  display: flex;
  margin-top: 180px;
  align-items: center;
  
  ${mediaqueries.tablet`
    margin-top: 18px;
  `}
`;

const CopyrightDateText = styled.div`
  padding-left: 20px;
  font-size: 15px;
  line-height: 85.5%;
  letter-spacing: -.04em;
`;

export default Copyright;
